import style from "./Menu.module.scss";
import cn from "classnames";
import { useAppSelector } from "store/hooks";

const role: string = process.env.NODE_ENV === "production" ? window.location.origin.includes("admin") ? "admin" : "user" : window.location.pathname.includes("admin") ? "admin" : "user"

export function Menu({
  linksGroups
}: {
  linksGroups: {
    nameGroup: string,
    links: JSX.Element[]
  }[]
}) {
  const isShowBurgerMenu = useAppSelector(state => state.global.isShowBurgerMenu)

  return (
    <nav data-burger style={role === "admin" ? {
      top: "70px"
    } : {}} className={cn(style.nav, isShowBurgerMenu ? "max-sm:block" : "max-sm:hidden")}>
      <div className={style.limit}>
        {
          linksGroups.map((group, i) => (
            <div key={i} className={style.linksGroup}>
              <p className={style.groupLabel}>{group.nameGroup}:</p>
              {group.links}
            </div>
          ))
        }
      </div>
      <img
        className={style.menuRocket}
        src="/image/menu/rocket.png"
        alt="menu rocket"
      />
    </nav>
  );
}